// extracted by mini-css-extract-plugin
module.exports = {"privacy":"privacy-module--privacy--mMhL6","sansSerif":"privacy-module--sansSerif--lZieD","bold":"privacy-module--bold--3eaKy"};